<template>
    <nav class="navbar navbar-expand navbar-light navbar-bg">
        <div class="sidebar-toggle cursor-pointer" @click="changeSidebar">
            <i class="hamburger align-self-center"></i>
        </div>

        <!--        <form class="d-none d-sm-inline-block">-->
        <!--            <div class="input-group input-group-navbar">-->
        <!--                <input-->
        <!--                    aria-label="Search"-->
        <!--                    class="form-control"-->
        <!--                    placeholder="Search…"-->
        <!--                    type="text">-->
        <!--                <button class="btn" type="button">-->
        <!--                    <svg-->
        <!--                        class="feather feather-search align-middle"-->
        <!--                        fill="none"-->
        <!--                        height="24"-->
        <!--                        stroke="currentColor"-->
        <!--                        stroke-linecap="round"-->
        <!--                        stroke-linejoin="round"-->
        <!--                        stroke-width="2"-->
        <!--                        viewBox="0 0 24 24"-->
        <!--                        width="24"-->
        <!--                        xmlns="http://www.w3.org/2000/svg">-->
        <!--                        <circle-->
        <!--                            cx="11"-->
        <!--                            cy="11"-->
        <!--                            r="8" /><line-->
        <!--                                x1="21"-->
        <!--                                x2="16.65"-->
        <!--                                y1="21"-->
        <!--                                y2="16.65" />-->
        <!--                    </svg>-->
        <!--                </button>-->
        <!--            </div>-->
        <!--        </form>-->

        <div class="navbar-collapse collapse">
            <ul class="navbar-nav navbar-align align-items-center">
                <li v-if="false && $user.isUser && pendingPassingsCount > 0" class="nav-item me-3">
                    <dropdown-ui>
                        <template #button>
                            <div class="nav-icon pe-md-0 dropdown-toggle position-relative">
                                <vue-feather type="bell" size="18" />
                                <span class="badge bg-danger rounded-pill position-absolute translate-middle" style="top: -4px; right: -8px; font-size: 10px;">{{ pendingPassingsCount }}</span>
                            </div>
                        </template>
                        <template #list>
                            <div class="dropdown-item text-wrap" style="max-width: 320px;">
                                Чтобы считалось время проживания:
                                <span v-if="hasPendingWrongDorm"> поменяйте общежитие студента — сейчас он приписан к другому общежитию.</span>
                                <span v-if="hasPendingNotFound"> Если студент не найден — добавьте студента.</span>
                                Затем учтите проход на странице «Ожидающие проходы».
                            </div>
                            <div class="dropdown-item">
                                <router-link to="/pending-passings" class="btn btn-sm btn-primary">Перейти к ожидающим проходам</router-link>
                            </div>
                        </template>
                    </dropdown-ui>
                </li>
                <!-- ✅ Скрыт колокольчик уведомлений -->
                <!--<li class="nav-item me-3">
                    <dropdown-ui>
                        <template #button>
                            <div class="nav-icon pe-md-0 dropdown-toggle position-relative">
                                <vue-feather type="bell" size="18" />
                                <span v-if="unreadCount()" class="badge bg-danger rounded-pill position-absolute translate-middle" style="top: -4px; right: -8px; font-size: 10px;">{{ unreadCount() }}</span>
                            </div>
                        </template>
                        <template #list>
                            <div class="dropdown-item text-muted" v-if="!notifications.length">Уведомлений нет</div>
                            <div class="dropdown-item" v-for="n in notifications" :key="n.id" @click="onNotificationClick(n)">
                                <div class="d-flex flex-column">
                                    <div class="fw-bold">{{ n.title }}</div>
                                    <div class="small">{{ n.message }}</div>
                                </div>
                            </div>
                            <div class="dropdown-item text-end" v-if="notifications.length">
                                <button class="btn btn-link p-0" @click.stop="markAllRead()">Пометить прочитанными</button>
                            </div>
                        </template>
                    </dropdown-ui>
                </li>-->
                <!--                <li class="nav-item me-2">-->
                <!--                    <div v-if="$user.isSuperAdmin" class="badge badge-danger-light">-->
                <!--                        СуперАдмин-->
                <!--                    </div>-->
                <!--                    <div v-if="$user.isAdmin" class="badge badge-danger-light">-->
                <!--                        Администратор-->
                <!--                    </div>-->
                <!--                    <div v-if="$user.isManager" class="badge badge-danger-light">-->
                <!--                        Менеджер-->
                <!--                    </div>-->
                <!--                </li>-->
                <!--                <li class="nav-item dropdown">-->
                <!--                    <dropdown-ui>-->
                <!--                        <template #button>-->
                <!--                            <div class="nav-flag dropdown-toggle">-->
                <!--                                <img-->
                <!--                                    v-if="langCode === 'ru'"-->
                <!--                                    :alt="langCode"-->
                <!--                                    src="../assets/img/flags/ru.png">-->
                <!--                                <img-->
                <!--                                    v-if="langCode === 'en'"-->
                <!--                                    :alt="langCode"-->
                <!--                                    src="../assets/img/flags/en.png">-->
                <!--                                <img-->
                <!--                                    v-if="langCode === 'kz'"-->
                <!--                                    :alt="langCode"-->
                <!--                                    src="../assets/img/flags/kz.png">-->
                <!--                            </div>-->
                <!--                        </template>-->
                <!--                        <template #list>-->
                <!--                            <template v-for="locale in supportLocales" :key="locale.code">-->
                <!--                                <div-->
                <!--                                    class="dropdown-item cursor-pointer"-->
                <!--                                    @click="setLocale(locale.code)">-->
                <!--                                    <img-->
                <!--                                        :alt="locale.name"-->
                <!--                                        class="align-middle me-1"-->
                <!--                                        :src="require('../assets/img/flags/' + locale.code + '.png')"-->
                <!--                                        width="20">-->
                <!--                                    <span class="align-middle">{{ locale.name }}</span>-->
                <!--                                </div>-->
                <!--                            </template>-->
                <!--                        </template>-->
                <!--                    </dropdown-ui>-->
                <!--                </li>-->
                <li class="nav-item">
                    <dropdown-ui>
                        <template #button>
                            <div class="d-flex align-items-center">
                                <div class="nav-icon pe-md-0 dropdown-toggle">
                                    <div class="rounded-circle rounded ava d-flex justify-content-center align-items-center" :style="'background-color: ' + $user.fill">
                                        <vue-feather
                                            size="16"
                                            :style="'color: ' + $user.color"
                                            type="user" />
                                    </div>
                                </div>
                                <div class="ms-3 fw-bolder">
                                    {{ $user.firstName }}
                                    <!--                                    {{ correctPhoneNumber($user.phone) }}-->
                                </div>
                            </div>
                        </template>
                        <template #list>
                            <div class="dropdown-item cursor-pointer" @click="logout">
                                Выход
                            </div>
                        </template>
                    </dropdown-ui>
                </li>
            </ul>
        </div>
    </nav>
</template>

<script lang="ts">
import { defineComponent, toRef, ref } from "vue";
import { i18n, lang, setLocale } from "@/composables/useLocale";
import { SUPPORT_LOCALES } from "@/configs/locales";
import { appStore } from "@/store/appStore";
import { userStore } from "@/store/userStore";
import { useRouter } from "vue-router";
import { isMobile, isNotMobile } from "@/composables/useBreakpoints";
import correctPhoneNumber from "@/utils/correctPhoneNumber";
// import { notificationsStore } from "@/store/notificationsStore"; // ✅ Скрыт колокольчик

export default defineComponent({
    name: "HeaderComponent",
    setup() {
        const langCode = ref(lang);
        const supportLocales = SUPPORT_LOCALES;
        const { sidebar, setCompactSidebar, setDefaultSidebar } = appStore();
        const { logout: userLogout, user } = userStore();
        const pendingPassingsCount = ref(0);
        const hasPendingWrongDorm = ref(false);
        const hasPendingNotFound = ref(false);
        // const { notifications, unreadCount, markAllRead, markRead } = notificationsStore(); // ✅ Скрыт колокольчик
        // const onNotificationClick = (n: any) => {
        //     markRead(n.id);
        //     if (n.routePath) {
        //         router.push({ path: n.routePath, query: n.routeQuery || {} });
        //     }
        // };
        const router = useRouter();

        function changeSidebar() {
            if (!isMobile) {
                if (sidebar.value == 'default') setCompactSidebar();
                else setDefaultSidebar();
            } else {
                let sidebar = <HTMLElement>document.getElementById('sidebar');
                if (sidebar.classList.contains('collapsed')) {
                    sidebar.classList.remove('collapsed');
                } else {
                    sidebar.classList.add('collapsed');
                }
            }
        }

        function logout() {
            userLogout().then((r: any) => {
	            location.href = '/auth';
                // router.push('/auth');
            });
        }

      return { langCode, supportLocales, setLocale, changeSidebar, logout, correctPhoneNumber, pendingPassingsCount, hasPendingWrongDorm, hasPendingNotFound }; // ✅ Скрыт колокольчик - убрал notifications, unreadCount, markAllRead, onNotificationClick
    },
    components: {
    },
});
</script>

<style scoped lang="scss">
  .ava {
    width: 30px;
    height: 30px;
  }
</style>
